import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route } from 'react-router-dom'
import Row, { RowButton, RowSpacer } from '../../../common/components/Row'
import Sidebar from '../../../common/components/Sidebar'
import Text from '../../../common/components/Text'
import Icon from 'common/components/Icon'

const SidebarItem = ({ to, children }) => {
  return (
    <Route path={to}>
      {({ match }) => (
        <RowButton to={to}>
          <Icon icon={match ? 'circle-filled' : 'none'} />
          <Text medium>{children}</Text>
        </RowButton>
      )}
    </Route>
  )
}

const SettingsSidebar = () => {
  const { t } = useTranslation()

  return (
    <Sidebar>
      <RowButton top to="/">
        <Icon icon="arrow-left" />
        <Text medium>{t('sidebar.home')}</Text>
      </RowButton>
      <SidebarItem to="/settings/account">{t('settings.account')}</SidebarItem>
      <SidebarItem to="/settings/plan">{t('settings.plan')}</SidebarItem>
      <RowSpacer />
      <Row>
        <Text small grey>
          Version: {process.env.REACT_APP_VERSION}
        </Text>
      </Row>
    </Sidebar>
  )
}

export default SettingsSidebar
